module.exports = __webpack_public_path__ + "img/蜂蜜認證.3cb63439.png";